export default __webpack_public_path__ + "static/media/Tisha Singhal.e52ca2f6.jpg";